module.exports = __webpack_public_path__ + "assets/240ee4ab601a36732990d19192191d1d.png";